import type { z } from 'zod'
import type { NoContext } from '~/services/api/contracts/NoContext'
import { MenuCustomizationGroupIndexQuerySchema } from '~/services/api/generated'

const schema = MenuCustomizationGroupIndexQuerySchema.strict()

// ListMenuCustomizationGroupsRequest
export const MenuCustomizationGroupIndex = (
  _context: NoContext
): z.ZodType<z.output<typeof schema>> => schema
